<app-slider></app-slider>

<div class="rts-ad-space">
    <div class="container">
        <div class="row py-40">

            @for (item of Announcements(); track $index) {
            @if (!item.isDefault) {
            <a target="_blank" [href]="item?.url" class="col-md-4 home-ad-space">
                <app-ads [imageSrc]="item?.image?.path | imageUrl" [altText]="item?.name">
                </app-ads>
            </a>
            }
            @else {
            <app-ads imageSrc="images/ad/530.250.01.png" class="col-md-4">
            </app-ads>
            }
            }

        </div>
    </div>
</div>

<app-aboutus-home></app-aboutus-home>
<app-sponsor [bronze]="false"></app-sponsor>
<app-doctor-slider></app-doctor-slider>
<app-feature></app-feature>
<app-blog-slider></app-blog-slider>
<app-contactus-home></app-contactus-home>
<app-modal></app-modal>
@if(sponsers().length > 0){
<app-sponsor [bronze]="true"></app-sponsor>
}